import React from 'react';

interface QuizActionButtonProps {
  label: string;
  onClick: () => void;
  testId?: string;
}

const QuizActionButton: React.FC<QuizActionButtonProps> = ({
  label,
  onClick,
  testId,
}) => {
  return (
    <button
      data-testid={testId}
      className="text-white text-center text-base whitespace-nowrap justify-center items-center self-center border border-[color:var(--primary,#0D6EFD)] bg-blue-600 max-w-full px-4 py-3 rounded-lg border-solid hover:bg-blue-400
      max-sm:mb-4
      max-md:mb-10 max-md:px-5"
      onClick={onClick}
    >
      {label}
    </button>
  );
};

export default QuizActionButton;
